import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import Menubar from '../Menubar/Menubar';

export default class MenubarExample extends Component {

  state = {
    items: ['Arabic', 'Danish', 'English', 'French', 'Norwegian', 'Zulu'],
    selected: 0,
    showUnderline: true,
  };

  onRemove = (e, index) => {
    const items = this.state.items.slice();

    items.splice(index, 1);
    this.setState({
      items,
      selected: Math.max(0, Math.min(this.state.selected, items.length - 1))
    });
  };

  onClick = (e, selected) => {
    this.setState({ selected });
    window.showAppInfo(e.target.innerHTML);
  };

  onChange = e => this.setState(e.target.value);

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={Menubar.defaultProps} propTypes={Menubar.propTypes} propValues={this.state} onChange={this.onChange}/>
        <Menubar {...this.state} onClick={this.onClick} onRemove={this.onRemove}>
          {this.state.items.map((title, index) => <Button key={index}>{title}</Button>)}
        </Menubar>
        <SourceCode querySelector=".menubar-example .core-menubar"/>
      </Example>
    );
  }

}
